<div class="accordion" id="accordionExample" style="margin-top: -30px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button aria-controls="collapse0" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse0" data-bs-toggle="collapse" type="button">
                Aangifte en premie(inkomen) Zorgverzekeringswet
            </button>
        </h2>
        <div aria-labelledby="heading0" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse0">
            <div class="accordion-body">
                De belastingplichtige of de werkgever/uitkeringsinstantie betaalt de inkomensafhankelijke bijdrage Zorgverzekeringswet
                (bijdrage Zvw) aan de Belastingdienst. Deze bijdrage is een bijdrage die jij of de
                werkgever/uitkeringsinstantie - naast de premie aan de zorgverzekeraar - betaalt voor de
                zorgverzekering. Hoe hoger het inkomen, hoe hoger de bijdrage.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button aria-controls="collapse1" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse1" data-bs-toggle="collapse" type="button">
                Percentages en bijdragen
            </button>
        </h2>
        <div aria-labelledby="heading1" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse1">
            <div class="accordion-body">
                Wil je meer informatie over de (premies voor de) zorgverzekeringswet? Benieuwd welke percentages er gelden in {{ this.year}}? Bekijk dan de
                informatie op de website van de belastingdienst:<br/>
                <div class="space10"></div>

                <snelstart-ui-button iconRight="arrow-up-right-from-square" size="small"
                                     type="secondary">
                    <a href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/werk_en_inkomen/zorgverzekeringswet/"
                       target="_blank">
                       Informatie over de zorgverzekeringswet
                    </a>
                </snelstart-ui-button>
            </div>
        </div>
    </div>

</div>


